import { useCountryContext } from '@archipro-website/localisation';
import { HeroSection } from './sections/HeroSection';
import { IntroSection } from './sections/IntroSection';
import { FeatureStripSection } from './sections/FeatureStripSection';
import { UsLaunchBannerSection } from './sections/UsLaunchBannerSection';
import { DiscoverProjectsSection } from './sections/DiscoverProjectsSection';
import { DiscoverProfessionalsSection } from './sections/DiscoverProfessionalsSection';
import { ProductsSection } from './sections/ProductsSection';
import { ArticlesSection } from './sections/ArticlesSection';
import { MagazineSection } from './sections/MagazineSection';
import { SectionSpacer } from './components/SectionSpacer';
import { ScrollReveal } from './components/ScrollReveal';
import { HomePageScope } from './home-page-scope';
import { useHomePageRevamp } from './use-is-home-page';

/**
 * New logged-out homepage (BC-4442). Sections are added top-to-bottom as they
 * are built; each reads what it needs from the `_app._index` loader. The old
 * `HomePage*` components are removed at cutover once every section has landed.
 */
export const HomePage = () => {
    // The "Coming to America" launch banner is US-only; NZ/AU skip the section.
    const isUS = useCountryContext().byCountry({
        US: true,
        AU: false,
        NZ: false,
    });
    const revamp = useHomePageRevamp();
    // The revamp's warm ground behind the sections below the banner.
    const spacerClassName = revamp ? 'bg-white md:bg-[#FDF7EE]' : 'bg-white';

    return (
        <HomePageScope>
            <HeroSection />
            <SectionSpacer
                height={197}
                mobileHeight={59}
                className={spacerClassName}
            />
            <ScrollReveal>
                <IntroSection />
            </ScrollReveal>
            {/* The revamp matches the banner-to-statement gap above, so the
                intro sits evenly between the two. */}
            <SectionSpacer
                height={revamp ? 197 : 160}
                mobileHeight={59}
                className={spacerClassName}
            />
            <ScrollReveal>
                <FeatureStripSection />
            </ScrollReveal>
            {isUS && (
                <>
                    <SectionSpacer
                        height={0}
                        mobileHeight={59}
                        className={spacerClassName}
                    />
                    <ScrollReveal>
                        <UsLaunchBannerSection />
                    </ScrollReveal>
                </>
            )}
            {/* These sections stagger their own header/cards reveals internally. */}
            <DiscoverProjectsSection />
            <DiscoverProfessionalsSection />
            <ProductsSection />
            <ArticlesSection />
            <MagazineSection />
        </HomePageScope>
    );
};
